import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, CreditCard, ChevronDown, Star, AlertTriangle, BookOpen, Users, TrendingUp, Globe, FileText, Lock, Zap, Briefcase } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { PricingGrid } from './PricingGrid';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/3yCrHqWK4b4kiKMYxKNDXi/mockups_teoria_de_las_organizaciones_.png'
};
const LINKS = {
  PACK_COMPLETO: 'https://mi-tienda-2-8952.myshopify.com/cart/51622247465280:1',
  PACK_COMPLETO_PROYECTOS: 'https://mi-tienda-2-8952.myshopify.com/cart/51625760325952:1',
  ORGA_ECONOMIA: 'https://mi-tienda-2-8952.myshopify.com/cart/51622301204800:1',
  ORGA_CONTABILIDAD: 'https://mi-tienda-2-8952.myshopify.com/cart/51622258082112:1',
  ORGA_EDUCACION_FINANCIERA: 'https://mi-tienda-2-8952.myshopify.com/cart/51622278365504:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(0);
  const packLinks = [LINKS.PACK_COMPLETO, LINKS.PACK_COMPLETO_PROYECTOS, LINKS.ORGA_ECONOMIA, LINKS.ORGA_CONTABILIDAD, LINKS.ORGA_EDUCACION_FINANCIERA];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white min-h-screen flex flex-col" data-id="element-89">
      <CountdownTimer data-id="element-90" />
      <SocialProofPopup data-id="element-91" />

      {/* HERO */}
      <section className="bg-black py-2 md:py-8 px-3 md:px-4 text-center" data-id="element-92">
        <div className="max-w-3xl mx-auto" data-id="element-93">
          <p className="text-yellow-400 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1 md:mb-2" data-id="element-94">
            ⭐ El recurso #1 para docentes de Teoría de las Organizaciones ⭐
          </p>

          <h1 className="text-xl md:text-3xl lg:text-4xl font-black text-white mb-1 md:mb-2 leading-tight" data-id="element-95">
            Todo tu año de organizaciones{' '}
            <span className="text-[#22c55e]" data-id="element-96">resuelto</span>
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity my-1 md:my-4" data-id="element-97">
            <img src={IMAGES.MAIN} alt="Kit Completo Teoría de las Organizaciones Mockup" className="w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-98" />
          </div>

          <p className="text-sm md:text-lg text-[#22c55e] font-bold italic mb-1 md:mb-2" data-id="element-99">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-xs md:text-sm text-gray-300 mb-2 md:mb-4 max-w-xl mx-auto" data-id="element-100">
            El sistema que usan los docentes de Teoría de las Organizaciones en
            Argentina para planificar todo el año en una tarde
          </p>

          <div className="flex justify-center gap-1 md:gap-2 mb-2 md:mb-3 flex-nowrap" data-id="element-101">
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap" data-id="element-102">
              <FileText className="w-2 h-2 md:w-2.5 md:h-2.5" data-id="element-103" /> 100% PDF
            </span>
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap" data-id="element-104">
              <Zap className="w-2 h-2 md:w-2.5 md:h-2.5" data-id="element-105" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap" data-id="element-106">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <button onClick={scrollToPricing} className="inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-xs md:text-base py-1.5 px-4 md:py-2 md:px-6 rounded-lg shadow-[0_0_20px_rgba(34,197,94,0.3)] transform hover:scale-105 transition-all duration-200 mb-1.5 md:mb-3 whitespace-nowrap" data-id="element-107">
            → QUIERO MI KIT COMPLETO AHORA
          </button>

          <div className="flex justify-center gap-1.5 md:gap-3 text-[9px] md:text-[10px] text-gray-500 font-medium flex-nowrap" data-id="element-108">
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-109">
              <ShieldCheck className="w-2.5 h-2.5 md:w-3 md:h-3 text-green-500" data-id="element-110" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-111">
              <Lock className="w-2.5 h-2.5 md:w-3 md:h-3 text-green-500" data-id="element-112" /> Pago
              seguro
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-113">
              <CreditCard className="w-2.5 h-2.5 md:w-3 md:h-3 text-green-500" data-id="element-114" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="bg-gray-50 py-3 md:py-8 px-4 border-t border-gray-200" data-id="element-115">
        <div className="max-w-2xl mx-auto" data-id="element-116">
          <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-3 md:mb-5" data-id="element-117">
            Si sos docente de Teoría de las Organizaciones, esto te va a sonar{' '}
            <span className="text-red-500 underline decoration-red-500/30 decoration-2 underline-offset-2" data-id="element-118">
              familiar…
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-3 text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-119">
            <p data-id="element-120">
              ❌ Buscás material de teoría de las organizaciones y encontrás
              contenidos genéricos que no se adaptan a secundaria
            </p>
            <p data-id="element-121">
              ❌ Armás actividades desde cero porque no existe material
              organizado para trabajar organizaciones, estructuras y gestión en
              el aula
            </p>
            <p data-id="element-122">
              ❌ Tus alumnos preguntan "¿para qué sirve esto?" cuando explicás
              organizaciones y no tenés ejemplos claros que los enganchen
            </p>
            <p data-id="element-123">
              ❌ Las planificaciones, trabajos prácticos y evaluaciones te
              consumen horas que no tenés
            </p>
            <p data-id="element-124">
              ❌ Querés trabajar empresas, emprendimientos, cultura
              organizacional y proyectos organizacionales, pero no tenés el
              material estructurado
            </p>
          </div>
        </div>
      </section>

      {/* STRATEGIC CTA (Merged) */}
      <section className="bg-white py-2 md:py-4 px-4 text-center" data-id="element-125">
        <button onClick={scrollToPricing} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-sm md:text-lg py-2 px-4 md:py-3 md:px-6 rounded-lg shadow-md transform hover:scale-105 transition-all duration-200 w-full md:w-auto max-w-xl" data-id="element-126">
          🚀 Quiero dejar de improvisar y tener todo resuelto
        </button>
      </section>

      {/* SOLUTION */}
      <section className="bg-black text-white py-4 md:py-8 px-4 text-center" data-id="element-127">
        <div className="max-w-3xl mx-auto" data-id="element-128">
          <span className="inline-block bg-green-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full mb-2 md:mb-4 uppercase tracking-wider" data-id="element-129">
            La Solución
          </span>
          <h2 className="text-2xl md:text-4xl font-black mb-2 md:mb-4" data-id="element-130">
            KIT COMPLETO{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-4" data-id="element-131">
              TEORÍA DE LAS ORGANIZACIONES LISTA
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-300 mb-3 md:mb-6 max-w-2xl mx-auto" data-id="element-132">
            Sistema integral de clases, actividades, proyectos y evaluaciones
            diseñadas específicamente para secundaria.
          </p>

          <div className="flex flex-col items-center gap-2 md:gap-3 text-sm md:text-base font-bold text-[#22c55e] text-left max-w-xl mx-auto" data-id="element-133">
            <span className="flex items-start gap-2 w-full" data-id="element-134">
              <Check className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-135" />{' '}
              Dar clases de teoría de las organizaciones con material claro,
              organizado y listo para usar
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-136">
              <Check className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-137" />{' '}
              Tener actividades y evaluaciones listas sin preparar nada
              adicional
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-138">
              <Check className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-139" />{' '}
              Cumplir con los NAP 2026 y justificar ante directivos con rúbricas
              por capacidades
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-140">
              <Check className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-141" />{' '}
              Conectar con tus alumnos usando ejemplos reales de empresas,
              organizaciones y emprendimientos
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-142">
              <Check className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-143" />{' '}
              Ahorrar horas de trabajo cada semana
            </span>
          </div>
        </div>
      </section>

      {/* CONTENTS ACCORDION */}
      <section className="bg-white py-4 md:py-8 px-4" data-id="element-144">
        <div className="max-w-3xl mx-auto" data-id="element-145">
          <div className="text-center mb-4 md:mb-6" data-id="element-146">
            <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-3" data-id="element-147">
              ¿QUÉ INCLUYE EL{' '}
              <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-2" data-id="element-148">
                KIT COMPLETO
              </span>{' '}
              TEORÍA DE LAS ORGANIZACIONES?
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-bold mb-1" data-id="element-149">
              360 páginas · 6 tomos · Alineado NAP 2026
            </p>
            <p className="text-xs md:text-sm text-gray-500" data-id="element-150">
              ✅ Tocá cada cuadernillo para ver su contenido
            </p>
          </div>

          <div className="space-y-1.5 md:space-y-2" data-id="element-151">
            {/* Tomo 1 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-152">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 0 ? null : 0)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-153">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-blue-600 flex-shrink-0" data-id="element-154" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-155">
                  TOMO 1 — Introducción a las Organizaciones
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 0 ? 'rotate-180' : ''}`} data-id="element-156" />
              </button>
              <AnimatePresence data-id="element-157">
                {openCuadernillo === 0 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-158">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-159">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-160">
                        Concepto de organización, tipos de organizaciones, rol
                        de las organizaciones en la sociedad y su impacto
                        económico y social.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 2 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-161">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 1 ? null : 1)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-162">
                <TrendingUp className="w-5 h-5 md:w-6 md:h-6 text-green-600 flex-shrink-0" data-id="element-163" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-164">
                  TOMO 2 — Estructura Organizacional
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 1 ? 'rotate-180' : ''}`} data-id="element-165" />
              </button>
              <AnimatePresence data-id="element-166">
                {openCuadernillo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-167">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-168">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-169">
                        Organigramas, jerarquías, roles dentro de las
                        organizaciones, departamentalización y modelos de
                        estructura organizacional.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 3 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-170">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 2 ? null : 2)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-171">
                <Users className="w-5 h-5 md:w-6 md:h-6 text-amber-500 flex-shrink-0" data-id="element-172" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-173">
                  TOMO 3 — Cultura Organizacional y Clima Laboral
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 2 ? 'rotate-180' : ''}`} data-id="element-174" />
              </button>
              <AnimatePresence data-id="element-175">
                {openCuadernillo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-176">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-177">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-178">
                        Valores organizacionales, liderazgo, comunicación
                        interna, trabajo en equipo y clima dentro de las
                        organizaciones.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 4 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-179">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 3 ? null : 3)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-180">
                <Globe className="w-5 h-5 md:w-6 md:h-6 text-red-600 flex-shrink-0" data-id="element-181" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-182">
                  TOMO 4 — Procesos Organizacionales
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 3 ? 'rotate-180' : ''}`} data-id="element-183" />
              </button>
              <AnimatePresence data-id="element-184">
                {openCuadernillo === 3 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-185">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-186">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-187">
                        Planificación, organización, dirección y control.
                        Procesos administrativos y toma de decisiones.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 5 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-188">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 4 ? null : 4)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-189">
                <Briefcase className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 flex-shrink-0" data-id="element-190" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-191">
                  TOMO 5 — Gestión de Recursos
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 4 ? 'rotate-180' : ''}`} data-id="element-192" />
              </button>
              <AnimatePresence data-id="element-193">
                {openCuadernillo === 4 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-194">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-195">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-196">
                        Recursos humanos, financieros y materiales. Roles
                        laborales, gestión del talento y funcionamiento de las
                        organizaciones.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 6 */}
            <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-197">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 5 ? null : 5)} className="w-full flex items-center gap-3 p-2 md:p-4 text-left cursor-pointer" data-id="element-198">
                <FileText className="w-5 h-5 md:w-6 md:h-6 text-purple-600 flex-shrink-0" data-id="element-199" />
                <h3 className="text-sm md:text-base font-bold text-gray-900 flex-1" data-id="element-200">
                  TOMO 6 — Proyecto Organizacional Escolar
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 5 ? 'rotate-180' : ''}`} data-id="element-201" />
              </button>
              <AnimatePresence data-id="element-202">
                {openCuadernillo === 5 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-203">
                    <div className="px-3 md:px-5 pb-3 md:pb-4 border-t border-gray-200 pt-2 md:pt-3" data-id="element-204">
                      <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-205">
                        Diseño y desarrollo de proyectos organizacionales para
                        trabajar en el aula con investigación, planificación y
                        presentación final.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-4 md:py-8 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 100%)'
    }} data-id="element-206">
        <div className="max-w-4xl mx-auto" data-id="element-207">
          <div className="text-center mb-4 md:mb-6" data-id="element-208">
            <h2 className="text-xl md:text-3xl font-black text-white mb-2 md:mb-3 leading-tight" data-id="element-209">
              <span className="text-[#22c55e]" data-id="element-210">BONUS</span> exclusivos incluidos
            </h2>

            <div className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-xs md:text-sm px-3 md:px-5 py-1.5 md:py-2 rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.4)] mb-4 md:mb-6" data-id="element-211">
              <span className="text-sm md:text-base" data-id="element-212">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 mb-4 md:mb-6" data-id="element-213">
            {/* Bonus 1 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-2 md:p-4 flex flex-col" data-id="element-214">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-215">
                01
              </span>
              <span className="inline-block bg-red-600 text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider mb-1.5 self-start" data-id="element-216">
                BONO #01
              </span>
              <h3 className="text-sm md:text-base font-bold text-white mb-1" data-id="element-217">
                📋 Planificación Anual
              </h3>
              <p className="text-gray-400 text-xs leading-relaxed flex-1" data-id="element-218">
                Planificación anual completa. Incluye objetivos, contenidos por
                unidad, actividades sugeridas y criterios de evaluación.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-white/10" data-id="element-219">
                <span className="text-gray-500 text-[10px] line-through" data-id="element-220">
                  Valor $8.500
                </span>
                <span className="bg-[#22c55e] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-221">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-2 md:p-4 flex flex-col" data-id="element-222">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-223">
                02
              </span>
              <span className="inline-block bg-yellow-500 text-black text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider mb-1.5 self-start" data-id="element-224">
                BONO #02
              </span>
              <h3 className="text-sm md:text-base font-bold text-white mb-1" data-id="element-225">
                📚 120 Actividades
              </h3>
              <p className="text-gray-400 text-xs leading-relaxed flex-1" data-id="element-226">
                Banco de actividades listas: análisis de empresas, simulaciones
                organizacionales, debates y trabajos grupales.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-white/10" data-id="element-227">
                <span className="text-gray-500 text-[10px] line-through" data-id="element-228">
                  Valor $8.500
                </span>
                <span className="bg-[#22c55e] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-229">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-2 md:p-4 flex flex-col" data-id="element-230">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-231">
                03
              </span>
              <span className="inline-block bg-red-600 text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider mb-1.5 self-start" data-id="element-232">
                BONO #03
              </span>
              <h3 className="text-sm md:text-base font-bold text-white mb-1" data-id="element-233">
                📊 Sistema PRO Evaluación
              </h3>
              <p className="text-gray-400 text-xs leading-relaxed flex-1" data-id="element-234">
                Evaluaciones diagnósticas, rúbricas de corrección, evaluaciones
                integradoras y herramientas para evaluar proyectos.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-white/10" data-id="element-235">
                <span className="text-gray-500 text-[10px] line-through" data-id="element-236">
                  Valor $8.000
                </span>
                <span className="bg-[#22c55e] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-237">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="max-w-xs mx-auto bg-[#111633] border border-[#1e2a5a] rounded-xl p-3 md:p-4 text-center" data-id="element-238">
            <p className="text-gray-400 text-xs md:text-sm mb-1" data-id="element-239">
              Valor total de los 3 bonus:
            </p>
            <p className="text-white text-lg md:text-xl font-black line-through decoration-red-500 decoration-2 mb-1.5 md:mb-2" data-id="element-240">
              $25.000
            </p>
            <p className="text-gray-400 text-xs md:text-sm mb-1" data-id="element-241">
              Hoy te los llevás por:
            </p>
            <p className="text-[#22c55e] text-2xl md:text-4xl font-black mb-1.5 md:mb-2" data-id="element-242">
              $0
            </p>
            <p className="text-[#22c55e] font-bold text-[10px] md:text-xs" data-id="element-243">
              ✨ Incluidos GRATIS con tu compra ✨
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-4 md:py-8 px-4" style={{
      background: 'linear-gradient(180deg, #0d1229 0%, #0a0e1a 100%)'
    }} data-id="element-244">
        <div className="max-w-2xl mx-auto text-center" data-id="element-245">
          <h2 className="text-lg md:text-2xl font-black text-yellow-400 mb-3 md:mb-5 uppercase tracking-wide" data-id="element-246">
            El precio de lanzamiento termina en
          </h2>

          <div className="flex items-center justify-center gap-1.5 md:gap-3 mb-3 md:mb-5" data-id="element-247">
            <div className="flex flex-col items-center" data-id="element-248">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-16 md:h-16 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-249">
                <span className="text-white text-xl md:text-3xl font-black" data-id="element-250">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[9px] md:text-[10px] font-bold uppercase tracking-wider mt-1" data-id="element-251">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-3xl font-black -mt-4" data-id="element-252">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-253">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-16 md:h-16 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-254">
                <span className="text-white text-xl md:text-3xl font-black" data-id="element-255">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[9px] md:text-[10px] font-bold uppercase tracking-wider mt-1" data-id="element-256">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-3xl font-black -mt-4" data-id="element-257">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-258">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-16 md:h-16 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-259">
                <span className="text-white text-xl md:text-3xl font-black" data-id="element-260">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[9px] md:text-[10px] font-bold uppercase tracking-wider mt-1" data-id="element-261">
                Segundos
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-3 md:mb-5" data-id="element-262">
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[10px] md:text-xs font-medium px-2.5 py-1.5 rounded-md" data-id="element-263">
              🔥 Últimas unidades
            </span>
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[10px] md:text-xs font-medium px-2.5 py-1.5 rounded-md" data-id="element-264">
              📢 Oferta Lanzamiento
            </span>
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[10px] md:text-xs font-medium px-2.5 py-1.5 rounded-md" data-id="element-265">
              📈 Precio sube al terminar
            </span>
          </div>

          <div className="max-w-sm mx-auto mb-3 md:mb-5" data-id="element-266">
            <div className="relative w-full h-3 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-267">
              <div className="h-full rounded-full" style={{
              width: '72%',
              background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)'
            }} data-id="element-268" />
            </div>
            <p className="text-gray-400 text-[10px] font-bold mt-1.5 uppercase tracking-wider" data-id="element-269">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-4 md:py-8 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-270">
        <div className="max-w-4xl mx-auto" data-id="element-271">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-4 md:mb-6 italic" data-id="element-272">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-4" data-id="element-273">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-274" />

          {/* Features Box */}
          <div className="max-w-xl mx-auto bg-[#111633] border border-[#1e2a5a] rounded-xl p-3 md:p-5" data-id="element-275">
            <h3 className="text-white font-black text-sm md:text-base mb-2 md:mb-3 flex items-center gap-1.5" data-id="element-276">
              👑 PACK COMPLETO INCLUYE:
            </h3>
            <ul className="space-y-1.5 md:space-y-2" data-id="element-277">
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-278">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-279" />
                6 tomos de contenidos para todo el año
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-280">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-281" />
                120 actividades listas para el aula
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-282">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-283" />
                BONUS: Planificación anual completa
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-284">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-285" />
                BONUS: 120 actividades de organizaciones
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-286">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-287" />
                BONUS: Sistema PRO de evaluación
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-288">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-289" />
                Entrega inmediata por Drive (PDF)
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-290">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-291" />
                Acceso de por vida — sin vencimiento
              </li>
              <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-292">
                <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-293" />
                Garantía de satisfacción de 7 días
              </li>
            </ul>
          </div>

          <p className="text-center text-gray-600 text-[10px] md:text-xs mt-3 md:mt-4 flex items-center justify-center gap-1.5" data-id="element-294">
            <CreditCard className="w-3 h-3" data-id="element-295" />
            Transferencia · Mercado Pago · Tarjeta
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-white py-3 md:py-6 px-4" data-id="element-296">
        <div className="max-w-2xl mx-auto text-center" data-id="element-297">
          <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-298">
            🔽 ¿Cómo recibís el{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-2" data-id="element-299">
              material
            </span>
            ?
          </h2>

          <div className="grid grid-cols-3 gap-1.5 md:gap-4" data-id="element-300">
            <div className="relative" data-id="element-301">
              <div className="w-6 h-6 md:w-10 md:h-10 bg-gray-100 rounded-full flex items-center justify-center text-sm md:text-lg font-bold text-gray-900 mx-auto mb-1 md:mb-2 border-2 border-gray-200" data-id="element-302">
                1
              </div>
              <h3 className="text-[10px] md:text-sm font-bold text-gray-900 mb-0.5 md:mb-1" data-id="element-303">
                Comprás
              </h3>
              <p className="text-gray-600 text-[9px] md:text-xs leading-tight" data-id="element-304">
                Ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-305">
              <div className="w-6 h-6 md:w-10 md:h-10 bg-gray-100 rounded-full flex items-center justify-center text-sm md:text-lg font-bold text-gray-900 mx-auto mb-1 md:mb-2 border-2 border-gray-200" data-id="element-306">
                2
              </div>
              <h3 className="text-[10px] md:text-sm font-bold text-gray-900 mb-0.5 md:mb-1" data-id="element-307">
                Pagás
              </h3>
              <p className="text-gray-600 text-[9px] md:text-xs leading-tight" data-id="element-308">
                Pago seguro.
              </p>
            </div>
            <div className="relative" data-id="element-309">
              <div className="w-6 h-6 md:w-10 md:h-10 bg-gray-100 rounded-full flex items-center justify-center text-sm md:text-lg font-bold text-gray-900 mx-auto mb-1 md:mb-2 border-2 border-gray-200" data-id="element-310">
                3
              </div>
              <h3 className="text-[10px] md:text-sm font-bold text-gray-900 mb-0.5 md:mb-1" data-id="element-311">
                Descargás
              </h3>
              <p className="text-gray-600 text-[9px] md:text-xs leading-tight" data-id="element-312">
                Recibís el link.
              </p>
            </div>
          </div>

          <div className="mt-2 md:mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-1.5 md:p-3 inline-block" data-id="element-313">
            <p className="text-yellow-800 flex items-center justify-center gap-1 font-medium text-[10px] md:text-xs" data-id="element-314">
              <AlertTriangle className="w-3 h-3 md:w-4 md:h-4" data-id="element-315" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="bg-white py-4 md:py-8 px-4 border-t border-gray-100" data-id="element-316">
        <div className="max-w-2xl mx-auto text-center" data-id="element-317">
          <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-[#22c55e] mx-auto mb-2 md:mb-3" data-id="element-318" />
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-1.5 md:mb-2" data-id="element-319">
            Garantía de{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-2" data-id="element-320">
              Satisfacción Total
            </span>
          </h2>
          <p className="text-sm md:text-base text-gray-600" data-id="element-321">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="bg-gray-50 py-4 md:py-8 px-4" data-id="element-322">
        <div className="max-w-4xl mx-auto" data-id="element-323">
          <h2 className="text-xl md:text-3xl font-bold text-center text-gray-900 mb-4 md:mb-6" data-id="element-324">
            <span className="text-[#22c55e]" data-id="element-325">Testimonios</span> de Docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4" data-id="element-326">
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-327">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 md:mb-2" data-id="element-328">
                <Star className="w-3 h-3 fill-current" data-id="element-329" />
                <Star className="w-3 h-3 fill-current" data-id="element-330" />
                <Star className="w-3 h-3 fill-current" data-id="element-331" />
                <Star className="w-3 h-3 fill-current" data-id="element-332" />
                <Star className="w-3 h-3 fill-current" data-id="element-333" />
              </div>
              <p className="text-gray-700 text-xs md:text-sm mb-1.5 md:mb-2 italic" data-id="element-334">
                "Arranqué el año sin nada armado para Organizaciones y con este
                kit en una tarde ya tenía todo planificado. Las actividades son
                claras y los chicos las entienden al toque. Me salvó
                literalmente el cuatrimestre."
              </p>
              <div className="font-bold text-gray-900 text-[10px] md:text-xs" data-id="element-335">
                Soledad M., 34 años –{' '}
                <span className="text-gray-500 font-normal" data-id="element-336">
                  La Plata, Buenos Aires
                </span>
              </div>
            </div>

            <div className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-337">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 md:mb-2" data-id="element-338">
                <Star className="w-3 h-3 fill-current" data-id="element-339" />
                <Star className="w-3 h-3 fill-current" data-id="element-340" />
                <Star className="w-3 h-3 fill-current" data-id="element-341" />
                <Star className="w-3 h-3 fill-current" data-id="element-342" />
                <Star className="w-3 h-3 fill-current" data-id="element-343" />
              </div>
              <p className="text-gray-700 text-xs md:text-sm mb-1.5 md:mb-2 italic" data-id="element-344">
                "Doy Teoría de las Organizaciones en dos escuelas y siempre me
                costaba encontrar material que no fuera universitario. Este kit
                está pensado para secundaria de verdad. Los trabajos prácticos
                son excelentes y las rúbricas me facilitan la corrección."
              </p>
              <div className="font-bold text-gray-900 text-[10px] md:text-xs" data-id="element-345">
                Ricardo G., 41 años –{' '}
                <span className="text-gray-500 font-normal" data-id="element-346">
                  Rosario, Santa Fe
                </span>
              </div>
            </div>

            <div className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-347">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 md:mb-2" data-id="element-348">
                <Star className="w-3 h-3 fill-current" data-id="element-349" />
                <Star className="w-3 h-3 fill-current" data-id="element-350" />
                <Star className="w-3 h-3 fill-current" data-id="element-351" />
                <Star className="w-3 h-3 fill-current" data-id="element-352" />
                <Star className="w-3 h-3 fill-current" data-id="element-353" />
              </div>
              <p className="text-gray-700 text-xs md:text-sm mb-1.5 md:mb-2 italic" data-id="element-354">
                "Lo que más me gustó es el Tomo 6 del proyecto organizacional.
                Mis alumnos armaron proyectos de empresas simuladas y fue la
                mejor experiencia del año. Los directivos quedaron impresionados
                con las presentaciones."
              </p>
              <div className="font-bold text-gray-900 text-[10px] md:text-xs" data-id="element-355">
                Claudia V., 39 años –{' '}
                <span className="text-gray-500 font-normal" data-id="element-356">
                  Córdoba Capital
                </span>
              </div>
            </div>

            <div className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-357">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 md:mb-2" data-id="element-358">
                <Star className="w-3 h-3 fill-current" data-id="element-359" />
                <Star className="w-3 h-3 fill-current" data-id="element-360" />
                <Star className="w-3 h-3 fill-current" data-id="element-361" />
                <Star className="w-3 h-3 fill-current" data-id="element-362" />
                <Star className="w-3 h-3 fill-current" data-id="element-363" />
              </div>
              <p className="text-gray-700 text-xs md:text-sm mb-1.5 md:mb-2 italic" data-id="element-364">
                "Soy docente hace 15 años y nunca encontré un material tan
                completo para Organizaciones. Antes perdía fines de semana
                enteros armando clases. Ahora abro el PDF, imprimo y listo. La
                planificación anual que viene de bonus es un golazo."
              </p>
              <div className="font-bold text-gray-900 text-[10px] md:text-xs" data-id="element-365">
                Alejandro D., 47 años –{' '}
                <span className="text-gray-500 font-normal" data-id="element-366">
                  San Miguel de Tucumán
                </span>
              </div>
            </div>

            <div className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-367">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 md:mb-2" data-id="element-368">
                <Star className="w-3 h-3 fill-current" data-id="element-369" />
                <Star className="w-3 h-3 fill-current" data-id="element-370" />
                <Star className="w-3 h-3 fill-current" data-id="element-371" />
                <Star className="w-3 h-3 fill-current" data-id="element-372" />
                <Star className="w-3 h-3 fill-current" data-id="element-373" />
              </div>
              <p className="text-gray-700 text-xs md:text-sm mb-1.5 md:mb-2 italic" data-id="element-374">
                "Mis alumnos siempre me decían '¿para qué sirve esto?' cuando
                daba organizaciones. Con las actividades de casos reales de
                empresas argentinas ahora se enganchan solos. El material de
                cultura organizacional y clima laboral les encanta porque lo
                relacionan con sus trabajos."
              </p>
              <div className="font-bold text-gray-900 text-[10px] md:text-xs" data-id="element-375">
                Natalia P., 36 años –{' '}
                <span className="text-gray-500 font-normal" data-id="element-376">Mendoza</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-4 md:py-8 px-4" data-id="element-377">
        <div className="max-w-2xl mx-auto" data-id="element-378">
          <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-4 md:mb-6" data-id="element-379">
            Preguntas{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-2" data-id="element-380">
              Frecuentes
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-2" data-id="element-381">
            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-382">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-383">
                ¿En qué formato recibo el material?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-384" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-385">
                Todo el material viene en formato PDF, listo para descargar,
                imprimir o usar de forma digital en cualquier dispositivo.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-386">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-387">
                ¿Cuánto tarda en llegar después de pagar?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-388" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-389">
                El acceso es inmediato. Apenas completás el pago, recibís el
                link de descarga en tu correo electrónico. Si no lo ves en la
                bandeja de entrada, revisá la carpeta de spam.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-390">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-391">
                ¿Puedo imprimir el material y usarlo en varias divisiones?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-392" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-393">
                Sí, podés imprimirlo todas las veces que necesites y usarlo en
                todas las divisiones y cursos donde des la materia. El acceso es
                de por vida.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-394">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-395">
                ¿Está alineado a los NAP 2026?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-396" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-397">
                Sí, el kit está 100% alineado a los Núcleos de Aprendizajes
                Prioritarios 2026. Podés presentar la planificación ante
                directivos con total confianza.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-398">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-399">
                ¿Qué pasa si no me sirve o no es lo que esperaba?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-400" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-401">
                Tenés 7 días de garantía total. Si el material no cumple tus
                expectativas por cualquier motivo, te devolvemos el 100% de tu
                dinero sin hacerte ninguna pregunta.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-402">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-403">
                ¿Para qué año de secundaria sirve?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-404" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-405">
                Sirve para todos los años donde se dicte Teoría de las
                Organizaciones en secundaria. El contenido es adaptable y cubre
                desde conceptos introductorios hasta proyectos avanzados.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-406">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-407">
                No tengo tarjeta de crédito, ¿puedo pagar de otra forma?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-408" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-409">
                Sí, aceptamos múltiples medios de pago: transferencia bancaria,
                Mercado Pago, tarjeta de débito y tarjeta de crédito. Elegí el
                que te resulte más cómodo.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-410">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-411">
                ¿Incluye planificación anual lista para presentar?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-412" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-413">
                Sí, como bonus incluimos una planificación anual completa con
                objetivos, contenidos por unidad, actividades sugeridas y
                criterios de evaluación. Lista para presentar ante directivos
                sin modificar nada.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-414">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-415">
                ¿Sirve si ya empecé el año y necesito material urgente?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-416" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-417">
                ¡Sí! Muchos docentes lo compran a mitad de año. El material está
                organizado por tomos temáticos, así que podés empezar por el
                tema que necesites sin seguir un orden fijo. Lo descargás al
                instante y lo usás en tu próxima clase.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-418">
              <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 text-sm md:text-base font-bold text-gray-900 list-none" data-id="element-419">
                ¿Qué diferencia hay entre el pack de $19.990 y el de $27.990?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-420" />
              </summary>
              <div className="px-3 pb-3 md:px-4 md:pb-4 text-xs md:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-2 md:pt-3" data-id="element-421">
                El pack de $19.990 incluye los 6 tomos de Teoría de las
                Organizaciones con todos los bonus. El pack de $27.990 incluye
                todo eso más el Sistema Avanzado de Proyectos Organizacionales,
                ideal si querés que tus alumnos desarrollen proyectos completos
                con guía paso a paso.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bg-black text-white py-4 md:py-8 px-4 text-center" data-id="element-422">
        <div className="max-w-3xl mx-auto" data-id="element-423">
          <h2 className="text-xl md:text-3xl font-black mb-1.5 md:mb-3" data-id="element-424">
            ¿Listo/a para{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-4" data-id="element-425">
              transformar tu año
            </span>{' '}
            en Teoría de las Organizaciones?
          </h2>
          <p className="text-sm md:text-base text-gray-400 mb-3 md:mb-5" data-id="element-426">
            Sumate a docentes que ya dejaron de improvisar.
          </p>

          <p className="text-gray-500 font-bold uppercase tracking-widest text-[10px] md:text-xs" data-id="element-427">
            📈 KIT COMPLETO TEORÍA DE LAS ORGANIZACIONES LISTA
          </p>
        </div>
      </section>

      {/* BOTTOM PRICING */}
      <section className="py-4 md:py-8 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-428">
        <div className="max-w-4xl mx-auto" data-id="element-429">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-4 md:mb-6 italic" data-id="element-430">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-2 underline-offset-4" data-id="element-431">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-432" />
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="bg-gray-900 py-3 md:py-4 px-4 text-center border-t border-gray-800" data-id="element-433">
        <p className="text-gray-400 text-xs md:text-sm" data-id="element-434">
          ¿Tenés dudas? Escribinos a{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-[#22c55e] font-bold hover:underline" data-id="element-435">
            kitonline27@gmail.com
          </a>
        </p>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-500 py-3 md:py-6 px-4 text-center text-[10px] md:text-xs border-t border-gray-800" data-id="element-436">
        <p className="mb-1.5 md:mb-3" data-id="element-437">
          © 2026 Kit Completo Teoría de las Organizaciones™
        </p>
        <div className="flex justify-center gap-3 md:gap-4" data-id="element-438">
          <span className="hover:text-white cursor-pointer" data-id="element-439">Términos</span>
          <span className="hover:text-white cursor-pointer" data-id="element-440">Privacidad</span>
          <span className="hover:text-white cursor-pointer" data-id="element-441">Soporte</span>
        </div>
      </footer>
    </div>;
}